require('es6-promise').polyfill()
require('es6-promise/auto')
/* eslint-disable import/first */
import Vue from 'vue'
import { sync } from 'vuex-router-sync'
import App from './App.vue'
import '@/utils/extend'
import '@/utils/message'
import '@/utils/filters'
import '@/utils/initFontSize'
import router from './router'
import store from './store'
import CodemaoSDK from '@/utils/iris'
import { isNemoApp } from '@/utils'
import { Notification } from 'element-ui'
import VueJsonp from 'vue-jsonp'
import '@/utils/xss'
// import jsp from '@/utils/jsp.js'
import VConsole from 'vconsole'
import dsbridge from '@/utils/dsbridge'
import * as Sentry from '@sentry/browser'
import * as Integrations from '@sentry/integrations'
import { WebMonitor } from '@frontend/web-monitor'

isNemoApp() && dsbridge.init()

sync(store, router)

const { iris } = window.CONFIG
if (iris && iris !== 'prod' && isNemoApp()) {
  // eslint-disable-next-line no-new
  new VConsole()
}

Vue.use(CodemaoSDK)
Vue.use(VueJsonp)
// Vue.use(jsp)

Vue.config.productionTip = false

// 在生产模式下便于在组件内打印某些事件是否触发及其默认输出值
// eg. <com @event="elog" />
if (process.env.NODE_ENV !== 'production') {
  Vue.prototype.elog = function(...arg) {
    console.log('elog', arg)
  }
}

if (process.env.NODE_ENV !== 'development') {
  Sentry.init({
    dsn: 'https://daa4718e57c244b29f89dfe8b8bc7778@sentry.codemao.cn/154',
    integrations: [new Integrations.Vue({ Vue, attachProps: true })],
    release: require('../package.json').version,
    logErrors: true,
    environment: CONFIG.env
  })
}

Vue.prototype.$notify = Notification

export default new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

// 接入性能监控平台
try {
  // eslint-disable-next-line no-new
  new WebMonitor() // 默认不用传参
} catch (error) {
  console.log(error)
}
